import {Injectable} from '@angular/core';
import {Severity, TSeverity} from './Severity';

export interface Message {
    title?: string;
    text: string;
    severity?: TSeverity;
}

@Injectable()
export class MessengerService {
    static DEFAULT_DELAY = 5000;

    private _messages: Message[] = [];
    private _delay: number = MessengerService.DEFAULT_DELAY;

    constructor() {
        this.handleError = this.handleError.bind(this);
    }

    get messages() {
        return this._messages;
    }

    set delay(delay: number) {
        this._delay = +delay || this._delay;
    }

    showInfo(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.INFO, delay);
    }

    showSuccess(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.SUCCESS, delay);
    }

    showWarning(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.WARNING, delay);
    }

    showError(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.DANGER, delay);
    }

    showPrimary(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.PRIMARY, delay);
    }

    showSecondary(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.SECONDARY, delay);
    }

    showLight(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.LIGHT, delay);
    }

    showDark(text: string, title?: string, delay?: number) {
        this.show(title, text, Severity.DARK, delay);
    }

    show(title: string, text: string, severity: TSeverity, delay?: number) {
        const message = {
            title,
            text,
            severity
        };
        this._messages.unshift(message);
        if (delay !== 0) {
            delay = delay || this._delay;
            setTimeout(() => {
                this.close(message);
            }, delay);
        }
    }

    close(message: Message): void {
        const index = this._messages.indexOf(message);
        if (index > -1) {
            this._messages.splice(index, 1);
        }
    }

    handleError(error: any): void {
        console.error(error);
        let message;
        try {
            message = error.error && error.error.message || error.message;
        } catch (e) {
            message = '';
        }
        this.showError(message, 'Hiba!');
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/messenger/messenger.service.ts